import {
  useWatch,
  type FieldErrors,
  type UseFormReturn,
} from 'react-hook-form';
import type { InternalTransferFormValues, SectionType } from './types';
import { useTranslation } from 'react-i18next';

interface Props {
  form: UseFormReturn<InternalTransferFormValues>;
  sectionType: SectionType;
}

interface ReturnValues {
  assetFieldName: 'assetFrom' | 'assetTo';
  accNumFieldName: 'accNumFrom' | 'accNumTo';
  watchedAccNumFrom: string;
  watchedAccNumTo: string;
  watchedAssetFromCode: string;
  watchedAssetToCode: string;
  watchedAssetCode: string;
  watchedAccNum: string;
  errors: FieldErrors<InternalTransferFormValues>;
  placeholder: string;
}

export const useInternalTransferValues = ({
  form,
  sectionType,
}: Props): ReturnValues => {
  const { t } = useTranslation();

  const assetFieldName = sectionType === 'from' ? 'assetFrom' : 'assetTo';
  const accNumFieldName = sectionType === 'from' ? 'accNumFrom' : 'accNumTo';

  const watchedAccNumFrom = useWatch({
    control: form.control,
    name: 'accNumFrom',
    defaultValue: '',
  });
  const watchedAccNumTo = useWatch({
    control: form.control,
    name: 'accNumTo',
    defaultValue: '',
  });

  const watchedAssetFromCode = useWatch({
    control: form.control,
    name: 'assetFrom',
    defaultValue: '',
  });
  const watchedAssetToCode = useWatch({
    control: form.control,
    name: 'assetTo',
    defaultValue: '',
  });

  const watchedAssetCode =
    assetFieldName === 'assetFrom' ? watchedAssetFromCode : watchedAssetToCode;
  const watchedAccNum =
    accNumFieldName === 'accNumFrom' ? watchedAccNumFrom : watchedAccNumTo;

  return {
    assetFieldName,
    accNumFieldName,
    watchedAccNum,
    watchedAccNumFrom,
    watchedAccNumTo,
    watchedAssetCode,
    watchedAssetFromCode,
    watchedAssetToCode,
    errors: form.formState.errors,
    placeholder: t(
      sectionType === 'from'
        ? 'internalTransferModal.assetPlaceholderFrom'
        : 'internalTransferModal.assetPlaceholderTo'
    ),
  };
};
